<template>
  <div class="header-nav">
    <div class="header-left">
      <img class="logo-img" :src="logoImg" @click="goRouter" />
      <UserTab />
    </div>

    <div class="header-right">
      <HeaderSearch v-if="!isMainRoute" class="header-search" />
      <div class="nav-right">
        <LangChange />
        <!-- 运费估算 -->
        <div class="estimation-link" @click="goEstimation">
          <span class="iconfont icon-estimate"></span>
        </div>
        <!-- 消息提示 -->
        <MsgTips />
        <!-- 购物车 -->
        <CartList placement="bottom" :iconSize="20" isHeader />
        <!-- 注册 -->
        <div v-if="!isLogin" class="sign-up" @click="goSignUp">
          {{ $t('form.register') }}
        </div>
        <!-- 个人中心 -->
        <UserAvatar />
      </div>
    </div>
  </div>
</template>

<script setup>
import { useUserStore } from '@/stores';
import { computed, defineProps } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import CartList from '../CartList';
import HeaderSearch from './HeaderSearch';
import LangChange from './LangChange';
import MsgTips from './MsgTips.vue';
import UserAvatar from './UserAvatar.vue';
import UserTab from './UserTab.vue';

const userStore = useUserStore();
const $router = useRouter();
const $route = useRoute()
const routeNames = ['search-list', 'home'];
const $props = defineProps({
  isHome: {
    type: Boolean,
    default: false,
  },
  isScroll: {
    type: Boolean,
    default: false,
  },
})
// const state = reactive({
//   allMessage: 0
// });
const logoImg = computed(() => {
  if ($props.isHome && !$props.isScroll) {
    return require(`@/assets/images/common/logo-light.png`)
  } else {
    return require(`@/assets/images/common/logo-${userStore.themeMode}.png`)
  }
})
const isLogin = computed(() => !!userStore.token);
const goRouter = () => {
  $router.push({ name: 'home' });
};

const isMainRoute = computed(() =>
  routeNames.find(item => item === $router.currentRoute.value.name)
);
const goSignUp = () => {
  $router.push({ name: 'login', query: { loginStatus: 'register', redirectUrl: `${$route.fullPath}` } });
};

const goEstimation = () => {
  $router.push({ name: 'estimation' });
};
// const goMessage = () => {
//   $router.push({ name: 'message' });
// };

</script>

<style lang="scss" scoped>
.header-nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-right: 60px;
  height: 80px;
  position: relative;

  .header-left {
    display: flex;
    justify-content: flex-start;
    align-items: center;

    .logo-img {
      width: 126px;
      height: 42px;
      margin-top: -14px;
      cursor: pointer;
      margin-left: 60px;
    }
  }

  .header-right {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .header-search {}

    .nav-right {
      // width: 290px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .sign-up {
        font-family: Montserrat;
        font-size: 16px;
        // color: var(--black-color-9);
        // width: 88px;
        height: 436x;
        line-height: 36px;
        border-radius: 918px;
        margin-left: 20px;
        text-align: center;
        cursor: pointer;

        &:hover {
          background-color: var(--line-light-gray-color);
        }
      }
    }

    :deep(.el-input__wrapper) {
      border: none;
    }
  }

  .estimation-link {
    cursor: pointer;
    font-size: 16px;
    width: 40px;
    height: 40px;
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;

    &:hover {
      background-color: var(--line-light-gray-color);
    }

    .icon-estimate {
      text-align: center;
      font-size: 20px;
    }

  }
}
</style>
